module.exports = __webpack_public_path__ + "img/17.6655036a.jpg";